import Application from "../../Application";
import ShowSuccessMessageInteractor from "../../core/interactor/notifications/ShowSuccessMessageInteractor";
import withStore, {
  TLoadingAwarePresenter,
  TPresentable
} from "../../core/presenter/withStore";
import { IRegistryInstitution } from "../model/RegistryInstitution";
import CreateOrganisationInteractor from "../../organisations/interactors/CreateOrganisationInteractor";
import UpdateOrganisationInteractor from "../../organisations/interactors/UpdateOrganisationInteractor";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import { IOrganisation } from "../../organisations/model/Organisation";
import OrganisationPresentationModel from "../../organisations/presenter/model/OrganisationPresentationModel";

export interface TOrganisationPresenter extends TLoadingAwarePresenter {
  organisations: IOrganisation[];
  institutions: IRegistryInstitution[];
}
export interface IOrganisationPresenter
  extends TOrganisationPresenter,
    TPresentable {
  loadAllOrganisations(organisations: IOrganisation[]): void;
  loadReferenceValues(institutions: IRegistryInstitution[]): void;
  createOrganisation(values: any): Promise<boolean>;
  showDetails(id: number): void;
  updateOrganisation(organisation: IOrganisation): void;
}
const defaultState: TOrganisationPresenter = {
  organisations: [],
  institutions: []
};
const OrganisationPresenter = withStore<
  IOrganisationPresenter,
  TOrganisationPresenter
>(({ application, store, loader, translate }): IOrganisationPresenter => {
  const _store = store;
  const _application: Application = application;
  const state = _store.getState<TOrganisationPresenter>();
  loader.start("organisationLoader");
  const loadAllOrganisations = (organisations: IOrganisation[]) => {
    const { institutions } = _store.getState<TOrganisationPresenter>();
    let organisationList = organisations.map((item) => {
      const institution = institutions?.find(
        (value) => value.code === item.hrmsInstitutionCode
      );
      return OrganisationPresentationModel(item, institution);
    });

    _store.update({ organisations: organisationList });
    loader.stop("organisationLoader");
  };
  const loadReferenceValues = (institutions: IRegistryInstitution[]) => {
    _store.update({ institutions });
  };

  const getAllOrganisations = async () => {
    let organisations = await _application.container
      .resolve<GetAllOrganisationsInteractor>("getAllOrganisations")
      .execute();
    loadAllOrganisations(organisations);
  };

  const createOrganisation = async (organisation: IOrganisation) => {
    loader.start("organisationLoader");
    await _application.container
      .resolve<CreateOrganisationInteractor>("createOrganisation")
      .execute(organisation);
    _application.container
      .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
      .execute(translate("editors.project.create_success_message"));
    loader.stop("organisationLoader");
    await getAllOrganisations();
    return true;
  };

  const updateOrganisation = async (organisation: IOrganisation) => {
    loader.start("organisationLoader");
    await _application.container
      .resolve<UpdateOrganisationInteractor>("updateOrganisation")
      .execute(organisation);
    _application.container
      .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
      .execute(translate("editors.project.create_success_message"));
    loader.stop("organisationLoader");
    await getAllOrganisations();
    return true;
  };

  const showDetails = (id: number) => {
    return _application.navigator.push({
      pathname: `/organisations/${id}`
    });
  };
  return {
    ...state,
    store: _store,
    loader,
    application: _application,
    translate,
    loadAllOrganisations,
    loadReferenceValues,
    createOrganisation,
    showDetails,
    updateOrganisation
  };
}, defaultState);
export default OrganisationPresenter;
